// TODO: import from @webflow/code
export enum PropType {
  Id = 'Id',
  Text = 'Text',
  RichText = 'RichText',
  Link = 'Link',
  Image = 'Image',
  Visibility = 'Visibility',
  Slot = 'Slot',
  Number = 'Number',
  Variant = 'Variant',
  Boolean = 'Boolean',
  TextNode = 'TextNode',
  Attributes = 'Attributes',
}

export enum Frameworks {
  React = 'React',
}

// Default values if a value cannot be serialized.
// These are mostly as a failsafe because we should always have
// the default value set in the dataType if no override is provided.
export const defaultString = '';
export const defaultNumber = 0;
export const defaultLink = {href: '#'};
export const defaultImage = {src: ''};
export const defaultBoolean = false;
